export const link = {
    mobile: '/live/mobile/',
    account: '/account/',
    live: '/live/',
};
